export const isInferiorVersion = (
  versionOne: string,
  versionTwo: string
): boolean => {
  const versionOneArray = versionOne.split('.').map(Number);
  const versionTwoArray = versionTwo.split('.').map(Number);
  if (versionOne === versionTwo) return false;

  const maxLength = Math.max(versionOneArray.length, versionTwoArray.length);

  for (let i = 0; i < maxLength; i++) {
    const v1 = versionOneArray[i] || 0;
    const v2 = versionTwoArray[i] || 0;

    if (v1 < v2) return true;
    if (v1 > v2) return false;
  }

  return false;
};
